import type { Density } from './types'

export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

export const densityRowClasses: Record<Density, string> = {
  compact: 'h-9', // ~36px
  normal: 'h-11', // ~44px
  comfortable: 'h-14', // ~56px
}

export function getSearchPlaceholder(
  globalSearch: boolean | { placeholder?: string } | undefined,
  fallback: string,
) {
  if (!globalSearch) return undefined
  if (typeof globalSearch === 'boolean') return fallback
  return globalSearch.placeholder ?? fallback
}

export function toSortParams(states: Array<{ id: string; desc: boolean }>) {
  return states.map((s) => ({ id: s.id, desc: s.desc }))
}
